import { PageHeader } from "@shared/components/PageHeader";
import { Button } from "@shared/ui/button";
import { Tabs } from "@shared/ui/tabs";
import { CircleCheck, CreditCard, FilePlus, Plus, Upload } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { CreditNoteList } from "../creditNote/creditnotelist";
import { PaymentList } from "../payments/list";
import { Summary } from "../payments/summary/summary";
import BulkPaymentList from "../bulkPayment/list/list";
import { RefundList } from "../refundPayment/list/list";

const PaymentsLandingPage = () => {
  const navigate = useNavigate();

  return (
    <div className="space-y-6">
      <div className="flex flex-col xl:flex-row justify-between xl:items-center gap-8">
        <div>
          <PageHeader
            title={"Payments Management"}
            subtitle="Manage all payment transactions, create credit notes, and track
            payment history across all channels"
          ></PageHeader>
        </div>

        <div className="flex gap-3">
          <Button
            variant="outline"
            onClick={() => navigate("/cx/payments/slip-lots")}
          >
            <FilePlus className="mr-2 h-4 w-4" />
            Slip Lots
          </Button>
          <Button
            variant="outline"
            onClick={() => navigate("/cx/payments/day-end-reconcilation")}
          >
            <CircleCheck className="mr-2 h-4 w-4" />
            Day-End Reconciliation
          </Button>
          <Button
            variant="outline"
            onClick={() => navigate("/cx/payments/check-register")}
          >
            <CreditCard className="mr-2 h-4 w-4" />
            Check Register
          </Button>
          <Button
            variant="outline"
            onClick={() => navigate("/cx/payments/bulk-payment/create")}
          >
            <Upload className="mr-2 h-4 w-4" />
            Bulk Payment
          </Button>
          <Button onClick={() => navigate("/cx/payments/create")}>
            <Plus className="mr-2 h-4 w-4" />
            Record Payment
          </Button>
        </div>
      </div>

      <Summary />

      <Tabs
        defaultValue="allPayments"
        className="w-full"
        tabsListClassName="grid w-full grid-cols-4 mb-6"
        urlMapping={{
          allPayments: "allPayments",
          creditNotes: "creditNotes",
          bulkPayment: "bulkPayment",
          refunds: "refunds",
        }}
        tabComponents={{
          allPayments: {
            label: "All Payments",
            component: <PaymentList />,
          },
          creditNotes: {
            label: "Credit Notes",
            component: <CreditNoteList />,
          },
          bulkPayment: {
            label: "Bulk Payments",
            component: <BulkPaymentList />,
          },
          refunds: {
            label: "Refunds",
            component: <RefundList />,
          },
        }}
      />
    </div>
  );
};

export default PaymentsLandingPage;
